import { useEffect, useState } from "react";

type SuccessPopupProps = {
  show: boolean;
  msg: string;
  id: string;
};

export default function SuccessPopup({ show, msg, id }: SuccessPopupProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
  }, []);
  useEffect(() => {
    if (show) {
      setVisible(true);
      window.dataLayer.push({
        event: "register_investor",
      });

      const timer = setTimeout(() => {
        setVisible(false);
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [show]);

  if (!visible) return null;

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: "28px",
          right: "28px",
          zIndex: 9999,
          animation: "slideIn 0.45s ease",
        }}
      >
        <div
          style={{
            minWidth: "360px",
            background: "#FFFFFF",
            border: "1px solid #E3E6EE",
            borderRadius: "16px",
            padding: "16px 18px",
            boxShadow: "0 14px 35px rgba(102,193,94,0.18)",
            display: "flex",
            alignItems: "center",
            gap: "14px",
            fontFamily: "Arial, sans-serif",
          }}
        >
          {/* Success Icon */}
          <div
            style={{
              width: "46px",
              height: "46px",
              minWidth: "46px",
              borderRadius: "50%",
              background: "linear-gradient(135deg,#66C15E,#66C15EDE)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#FFFFFF",
              fontSize: "22px",
              fontWeight: 700,
              boxShadow: "0 8px 18px rgba(102,193,94,0.28)",
            }}
          >
            ✓
          </div>

          {/* Content */}
          <div style={{ flex: 1 }}>
            <div
              style={{
                fontSize: "16px",
                fontWeight: 700,
                color: "#1F232C",
                marginBottom: "4px",
              }}
            >
              Success!
            </div>

            <div
              id={id}
              style={{
                fontSize: "14px",
                lineHeight: 1.45,
                color: "#5E5E5E",
                fontWeight: 500,
              }}
            >
              {msg}
            </div>
          </div>

          {/* Accent Bar */}
          <div
            style={{
              width: "4px",
              alignSelf: "stretch",
              borderRadius: "10px",
              background: "#66C15E",
            }}
          />
        </div>
      </div>

      <style>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-18px) translateX(20px) scale(.96);
          }
          to {
            opacity: 1;
            transform: translateY(0) translateX(0) scale(1);
          }
        }
      `}</style>
    </>
  );
}
